import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMathLessThan: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMathLessThan"><Path fillRule="evenodd" clipRule="evenodd" d="M19.8308 5.69238L4.69231 12.0001L19.8308 18.3078L20.6 16.4616L9.89231 12.0001L20.6 7.53854L19.8308 5.69238Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMathLessThan;
